export const EMPTY_FILTERS_MESSAGE = 'Bitte wählen Sie ein Depot oder ein Instrument um Transaktionen anzuzeigen.'